

























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';

import AbpBase from '../../../lib/abpbase'
import Organization from '@/store/entities/organization';

import Ajax from "@/lib/ajax";

@Component
export default class CreateOrganization extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  organization: Organization = new Organization();


  loading: boolean = false;


  save() {
    (this.$refs.organizationForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let response = await Ajax.post("/api/services/app/Organizations/Create", this.organization);
        this.loading = false;
        (this.$refs.organizationForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.organizationForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    }
  }

  organizationRule = {
    displayName: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('displayName')),
      trigger: 'blur'
    }],
    code: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('code')),
      trigger: 'blur'
    }],
  }
}
